import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/AdminModerateClaimModal';
// FOR ONE GRAPHQL QUERY
export const MODERATE_CLAIM = defineAsyncActionTypes(`${prefix}/MODERATE_CLAIM`);
